/**
 * Oren's fishing rod over the quay (lifted from lantern-water's `world.js`
 * `createTown`): a slender rod bending out over the canal, its line reaching
 * the water and a red float. Origin at the fisher's feet (the prototype's
 * 2.7, 6.7); the grip is at the height of the illustrated resident's hands
 * (0.72). No params.
 */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'fishing_rod',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { mesh, line, m } = ctx;
    const rod = new THREE.QuadraticBezierCurve3(new THREE.Vector3(0.16, 0.72, 0), new THREE.Vector3(0.95, 2.2, 0.05), new THREE.Vector3(1.6, 1.32, 0.2));
    mesh(root, new THREE.TubeGeometry(rod, 14, 0.018, 4, false), m.wood, 0, 0, 0);
    line(root, [1.6, 1.32, 0.2], [1.6, -0.63, 0.2], 0.008, m.canvas);
    mesh(root, ctx.sphere, m.red, 1.6, -0.64, 0.2, 0.04, 0.065, 0.04);
    return { root };
  },
};
